import request from '../utils/request'
export default {
	/*-------------------------------------------------------------生产 start-----------------------------------------------------------  */
    // 生产需求列表查询接口-田海光
    queryProductionDemandList({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/produce/queryProductionDemand`,
			data: params
		})
    },
    // 生产量预算列表查询接口-田海光
    queryList({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/produce/query`,
			data: params
		})
    },
    // 删除排产接口-田海光
    deleteProduction({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/produce/delete`,
			data: params
		})
    },
    // 保存生产量预算接口-田海光
    addProduction({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/produce/save`,
			data: params
		})
    },
    // 车间列表接口-田海光
    queryWorkshopList({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/produce/queryWorkshopList`,
			data: params
		})
    },
    // 产线列表接口-田海光
    queryProductLineList({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/produce/queryProductLineList`,
			data: params
		})
    },
    // 产线主数据列表接口-陈金龙
    selectProductLineList({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/produce/selectProductLineList`,
			data: params
		})
    },
    // 增加产线-陈金龙
    saveProductLine({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/produce/saveProductLine`,
			data: params
		})
    },
    // 删除产线-陈金龙
    deleteProductLine({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/produce/deleteProductLine`,
			data: params
		})
    },
    // 查询产线排产接口详情页-陈金龙
    queryProductLineAndDevice({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/produce/queryProductLineAndDevice`,
			data: params
		})
    },
    // 查询计量单位列表
    getMeasureUnitList({ ...params }) {
		return request({
			method: 'POST',
			url: `/mm/base/getMeasureUnitList`,
			data: params
		})
	}
	/*-------------------------------------------------------------生产 end-----------------------------------------------------------  */
}